import { render, staticRenderFns } from "./RecommendationForm.vue?vue&type=template&id=1fb23800"
import script from "./RecommendationForm.vue?vue&type=script&lang=js"
export * from "./RecommendationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports